import {
  CollaboratorReportingObject,
  CollaboratorReportingTotal,
  PaginatedResponseWithAdditionalData,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import {
  ReportingFilter,
  reportingQueryKeys,
} from "../query-keys/reporting.query-keys";

const getReporting = async (filters: ReportingFilter) => {
  try {
    const { data } = await privateAxios.get<
      PaginatedResponseWithAdditionalData<
        CollaboratorReportingObject,
        CollaboratorReportingTotal
      >
    >(`/reporting/general`, { params: filters });

    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useGetReporting = (filters: ReportingFilter) => {
  return useQuery({
    queryKey: reportingQueryKeys.all(filters),
    queryFn: () => getReporting(filters),
  });
};
